import React, { useState } from 'react';
import './css/Contact.css'; // Import your CSS file for ContactPage styling
import { Link } from 'react-router-dom';

// ContactPage component
const ContactPage = () => {
  const [agreement, setAgreement] = useState(false);
  const [buttonVisible, setButtonVisible] = useState(false);

  const [showEmailOptions, setShowEmailOptions] = useState(false);
  // const email = 'leoscopetestbed@surrey.ac.uk';
  const email = 's.fadaei@surrey.ac.uk';
  const emailSecond = 'n.sastry@surrey.ac.uk';

  const handleButtonClick = () => {
    setShowEmailOptions(true);
  };

  const handleSendEmailClick = () => {
    window.location.href = `mailto:${email}`;
  };

  const handleCopyClick = () => {
    // Logic to copy the email to the clipboard
    navigator.clipboard.writeText(email);
  };

  const handleAgreementChange = () => {
    setAgreement(!agreement);
    setButtonVisible(!buttonVisible);
  };

  return (
    <div className="contact-page-container">
      <div className="description-container">
        <h3 className="contact-title">Contact Us</h3>
	<p>
	The Leoscope Testbed is a global testbed of Starlink nodes (see map above) on which network measurement experiments can be conducted researchers for non-commercial purposes (e.g., for the purpose of writing a paper about the Starlink network).

If you wish to use the Leoscope Testbed and/or you wish to contribute a Starlink node to join the testbed, please contact us on s.fadaei@surrey.ac.uk or n.sastry@surrey.ac.uk. Note that your use of this testbed is subject to the EULA below.  
	</p>
  	
      </div>

      <div className="scroller-container">
      <h2>User Agreement</h2>
          <section>
            <p>The following is an agreement between University of Surrey(“UoS”) established by Royal Charter 1966 whose administrative offices are Guildford, Surrey GU2 7XH, United Kingdom and “You” the End User. UoS provides access to the web portal for a globally deployed testbed for broadband low-Earth orbit (LEO) satellite networks (“leoscope” or “Platform”) to you on the terms of this end user licence agreement (the “EULA”). You should read this EULA carefully before using the Platform. This EULA constitutes a legal and enforceable contract between you and UoS (each a “party” and together the “parties”). By using the Platform you agree to the terms of this Agreement. If you do not agree to this Agreement, you should immediately make no further use of the Platform.</p>
          </section>

          <section>
            <h3>Definitions</h3>
            <ol>
              <li>“End users” or “you” means anyone who uses the Platform whether accessed via su.ac.uk, or via a third party application using leoscope API.</li>
              <li>“Intellectual Property Rights” means all copyright and related rights, patents, rights to inventions, utility models, trade marks, service marks, trade, business and domain names, rights in trade dress or get-up, rights in goodwill or to sue for passing off, unfair competition rights, rights in designs, rights in computer software, database right, topography rights, moral rights, rights in confidential information (including know-how and trade secrets) and any other intellectual property rights, in each case whether registered or unregistered and including all applications for and renewals or extensions of such rights, and all similar or equivalent rights or forms of protection.</li>
              <li>“Licence” means the licence granted under clause 2.</li>
              <li>“Platform” means the online service owned (or licensed to) and operated by UoS , known as ‘LEOScope’, including any UoS Databases, and used by third parties for the purpose of conducting research into LEO Satellite network as well as any updates to it and any new versions which are made generally available by UOS from time to time.</li>
              <li>“Third Party Content” shall mean any content of a third party which is made accessible on the Platform.</li>
              <li>“Your Content” means any content or data which you submit through your use of the Platform.</li>
              <li>A “person” includes a natural person, corporate or unincorporated body.</li>
              <li> *** Unless the context otherwise requires, words in the singular include the plural and in the plural include the singular and references to one gender are references to the other genders.</li>
              <li>The words “include” and “including” (or similar) shall be deemed to have the words “without limitation” after them</li>
              <li>A reference to “writing” or “written” excludes nmail, unless you receive a response from UoS confirming that any email communication has been successfully received.</li>
            </ol>
          </section>

          <section>
            <h3>1. Your use of the Platform</h3>
            <ol>
              <li>You shall keep access details to the Platform strictly confidential. UoS shall not be liable for any losses or damage suffered by you due to the disclosure (whether accidental or deliberate) of secure links by you including the disclosure of data to others through the use of a shared device.</li>
              <li>You warrant that any information or content that you provide through your use of the Platform is accurate and true to the best of your knowledge.</li>
              <li>Your use of the Platform shall not violate any applicable law, regulation or any terms of use applicable to the use of Third Party Content.</li>
            </ol>
          </section>
          <section>
            <h3>2. Licence of the Platform</h3>
            <ol>
              <li><strong></strong> UoS hereby grants you a licence to use the Platform in accordance with the terms of this EULA.</li>
              <li><strong></strong> The Licence is revocable, non-exclusive, non-transferable and non-sublicensable.</li>
              <li><strong></strong> The Licence is granted to you only. Any other person with whom you may choose to share content via the Platform (such as a partner, agent, or client) shall use the Platform independently.</li>
              <li><strong></strong> You shall not use the Platform to build a product or service which competes with UoS or the Platform.</li>
              <li><strong></strong> You shall use all reasonable endeavours to prevent any unauthorised access to, or use of, the Platform and shall notify UoS promptly of any such unauthorised access or use.</li>
              <li><strong></strong> UoS may modify, suspend or discontinue any part of the Platform or otherwise make any changes it considers necessary to the Platform.</li>
            </ol>
          </section>
          <section>
            <h3>3. Intellectual Property & Copyright</h3>
            <ol>
              <li><strong></strong> UoS, its licensors, and customers own all Intellectual Property Rights in the Platform. Other than as expressly set out in this EULA, UoS does not grant you any Intellectual Property Rights in respect of the Platform. This does not affect your rights to use or copy software or parts of the software that may be published elsewhere by UoS under a different licence.</li>
              <li><strong></strong> Third-party content including text and images published via the Platform are the Intellectual Property of the publisher.</li>
              <li><strong></strong> You may not copy, decompile, reverse engineer, modify, or otherwise deal in any way with the Platform software, except those parts of the software that have been clearly published elsewhere under a license that allows this (for example, an open-source license). You may not remove any proprietary or license notices attached to the Platform or Third Party Content.</li>
            </ol>
          </section>

          <section>
            <h3>4. Your Content</h3>
            <ol>
              <li>
                <strong></strong> The Platform enables the undertaking of research and display of Your Content (“User Content”) and Service Content (”Third Party Content”) without substantive review. UoS is therefore a host of User Content which is accessed or processed by your use of the Platform, and UoS is in no way involved with or liable for the information contained in any User Content. UoS does not:
                <ol>
                  <li> initiate the transmission of User Content</li>
                  <li> select the receiver of any transmitted User Content; or</li>
                  <li> select, review or modify the information contained in any User Content (other than technical manipulations which take place in the course of the transmission of the User Content and which do not alter the integrity of the information contained in the User Content).</li>
                </ol>
              </li>
              <li><strong></strong> UoS will not be liable for any loss of Your Content. You are encouraged to keep your own back-up copy of Your Content. UoS will retain a copy of Your Content only for as long as necessary for the purpose of analysis and reporting.</li>
              <li><strong></strong> Any Intellectual Property Rights in the User Content shall remain with its owners or licensors. By uploading that User Content to the Platform, you grant to UoS and its customers an irrevocable, non-exclusive licence to copy, transmit and use that Content.</li>
              <li><strong></strong> UoS may conduct analysis on any User Content not designated as ‘Confidential’ ‘Sensitive’ or ‘Personal’ on the Platform for the purpose of improving the Platform. UoS shall own all Intellectual Property Rights in the product of such analysis.</li>
              <li><strong></strong> You may only distribute User Content created by you on the Platform created in accordance with the terms of this EULA. You shall not modify the Platform or any other related documentation.</li>
              <li>
                <strong></strong> Where any User Content may contain personal data (within the meaning set out in the Data Protection Act 1998 and the UK GDPR and all legislation enacted in the UK in respect of the protection of personal data; and any code of practice or guidance published by the ICO (or equivalent regulatory body) from time to time (the “Data Protection Legislation”)), UoS shall act only as a processor of such data. UoS will process this data in accordance with the instructions of the Controller and applicable data protection laws. UoS will not share your personal data with any other third party except a contractor bound by these same terms, nor will we use it for any other purpose of our own.
              </li>
              <li>
                <strong></strong> You will indemnify, defend and hold harmless UoS, from and against any claims, costs, damages, losses, liabilities and expenses (including legal fees) relating to any claims, actions, suits or proceedings by third parties against UoS arising out of or related in any way to either Party's use of User Content in accordance with this EULA.
              </li>
              <li>
                <strong></strong> All copies and versions of the User Content created must bear a valid copyright notice, either your own or UoS’ copyright notice that appears on the Platform, and you may not remove or alter any of UoS’ copyright, trade mark or other proprietary rights notice contained in any portion of the Platform.
              </li>
              <li>
                <strong></strong> You agree not to modify, rent, lease, loan, sell, distribute, or create derivative works based on the Platform, in any manner, and you shall not exploit the Platform in any unauthorized way whatsoever, including but not limited to, using the Platform to transmit any computer viruses, worms, trojan horses or other malware, or by trespassing or burdening network capacity.
              </li>
            </ol>
          </section>

          <section>
            <h3>5. Liability</h3>
            <ol>
              <li><strong></strong> UoS is not responsible or liable for the accuracy, relevance, and completeness of the information, data, guidance, advice, or Third Party Content displayed via the Platform.</li>
              <li>
                <strong></strong> This clause sets out UoS's entire financial liability (including any liability for the acts or omissions of its employees, agents, and sub-contractors) to you:
                <ol>
                  <li> arising under or in connection with this EULA;</li>
                  <li> in respect of any use made by you of the Platform;</li>
                  <li> any Third Party Content; and</li>
                  <li> In respect of any representation, misrepresentation (whether innocent or negligent), statement, or tortious act or omission (including negligence) arising under or in connection with this EULA.</li>
                </ol>
              </li>
              <li>
                <strong>5.3</strong> UoS disclaims all warranties and conditions express or implied, including, but not limited to, implied warranties of satisfactory quality and fitness for a particular purpose, in relation to the Platform, its use and the results of such use. UoS specifically disclaims any warranty:
                <ol>
                  <li> that the Platform and its availability shall be uninterrupted or error-free;</li>
                  <li> that defects shall be corrected;</li>
                  <li> that there are no viruses or other harmful components;</li>
                  <li> that the security methods employed shall be sufficient; or</li>
                  <li> regarding correctness, accuracy, usability or reliability.</li>
                </ol>
              </li>
              <li><strong></strong> All warranties, representations, conditions, and all other terms of any kind whatsoever implied by statute or common law are excluded from this EULA to the fullest extent permitted by law.</li>
              <li>
                <strong></strong> Nothing in this EULA excludes the liability of UoS:
                <ol>
                  <li> for death or personal injury caused by UOS’s negligence;</li>
                  <li> for fraud or fraudulent misrepresentation; or</li>
                  <li> any statutory liability not capable of limitation.</li>
                </ol>
              </li>
              <li>
                <strong></strong> Subject to clause 5.5, UoS shall not be liable whether in tort (including for negligence or breach of statutory duty), contract, misrepresentation (whether innocent or negligent), restitution or otherwise for any loss of profits, loss of business, depletion of goodwill and/or similar losses or loss or corruption of data or information, or pure economic loss, or for any special, indirect, or consequential loss costs, damages, charges or expenses however arising under this EULA.
              </li>
              <li>
                <strong></strong> Subject to clause 5.5, UoS’s total aggregate liability in contract, tort (including negligence or breach of statutory duty), misrepresentation (whether innocent or negligent), restitution or otherwise, arising in connection with the performance or contemplated performance of this EULA shall be limited to £1.
              </li>
            </ol>
          </section>

          <section>
            <h3>6. Confidentiality</h3>
            <ol>
              <li>
                <strong></strong> In this clause, “Confidential Information” means any information that is clearly labelled or identified as confidential or ought reasonably be treated as being confidential. Confidential Information excludes any information which:
                <ol>
                  <li> is or becomes publicly known other than through a breach of this EULA or other obligation of confidentiality;</li>
                  <li> was in the receiving Party’s lawful possession before the disclosure;</li>
                  <li> is lawfully disclosed to the receiving Party by a third party without restriction on disclosure;</li>
                  <li> is independently developed by the receiving Party and that independent development can be shown by written evidence; or</li>
                  <li> is required to be disclosed by law, by any court of competent jurisdiction, or by any regulatory or administrative body.</li>
                </ol>
              </li>
              <li>
                <strong></strong> Each Party shall hold the other’s Confidential Information in confidence and not make the other’s Confidential Information available to any third party unless that third party is subject to an equivalent duty of confidentiality. Neither Party shall use the other’s Confidential Information for any purpose other than the implementation of this EULA.
              </li>
              <li>
                <strong></strong> Each party shall take all reasonable steps to ensure that the other’s Confidential Information to which it has access is not disclosed or distributed by its employees, agents, or independent contractors in breach of the terms of this EULA.
              </li>
              <li>
                <strong></strong> This clause 7 shall survive termination of this EULA for a period of 5 years.
              </li>
            </ol>
          </section>
          <section>
            <h3>7. Data Protection</h3>
            <ol>
              <p>
                <strong></strong> UoS shall take all reasonable steps to protect your data, including personal data and will process your personal data in accordance with any instructions received and under all relevant Data Protection Legislation.
              </p>
            </ol>
          </section>
          <section>
            <h3>8. Termination</h3>
            <ol>
              <li>
                UoS may terminate this EULA at any time if we reasonably suspect that you have breached any term of this EULA.
              </li>
              <li>
                You may terminate this EULA at any time by providing written notice to UoS. Upon termination, you should immediately cease using the Platform.
              </li>
            </ol>
          </section>
          <section>
            <h3>9. Waiver</h3>
            <ol>
              <p>
                A waiver of any right under this EULA is only effective if it is in writing.
              </p>
            </ol>
          </section>
          <section>
            <h3>10. Severance</h3>
            <ol>
              <p>
                If any provision (or part of a provision) of this EULA is found to be invalid, unenforceable, or illegal, the other provisions (or parts of any provisions) shall remain in force.
              </p>
            </ol>
          </section>
          <section>
            <h3>11. Entire Agreement</h3>
            <ol>
              <p>
                This EULA constitutes the whole agreement between the parties and supersedes any previous agreement between them.
              </p>
            </ol>
          </section>
          <section>
            <h3>12. Bribery</h3>
            <ol>
              <p>
                UOS shall comply with all applicable laws, regulations, codes, and sanctions relating to bribery and corruption, including the Bribery Act 2010. We will not engage in an activity, practice, or conduct that would constitute an offence under that act, and shall promptly report to a relevant authority any request or demand for undue financial or other advantage that we receive whilst performing the terms of this agreement.
              </p>
            </ol>
          </section>
          <section>
            <h3>13. Equality</h3>
            <ol>
              <p>
                UoS shall comply with all applicable provisions of the Equality Act 2010, including discrimination on the basis of race, gender, age, sexuality, disability, or any other form of discrimination described in that act. We will handle complaints related to any form of discrimination or abuse quickly and seriously.
              </p>
            </ol>
          </section>
          <section>
            <h3>14. Modern Slavery</h3>
            <ol>
              <p>
                UOS will take all reasonable steps to ensure that no slavery or human trafficking (as defined by the Modern Slavery Act 2015 and other relevant UK legislation) is taking place in any part of its business or supply chains.
              </p>
            </ol>
          </section>
          <section>
            <h3>15. Assignment</h3>
            <ol>
              <p>
                You shall not assign, transfer, charge, sub-contract or deal in any other manner with all or any of its rights or obligations under this EULA, without the prior written consent of UoS.
              </p>
            </ol>
          </section>
          <section>
            <h3>16. Third Party Rights</h3>
            <ol>
              <p>
                This EULA does not confer any rights on any person or party (other than the parties to this EULA and (where applicable) their successors and permitted assigns) pursuant to the Contracts (Rights of Third Parties) Act 1999.
              </p>
            </ol>
          </section>
          <section>
            <h3>17. Governing law & jurisdiction</h3>
            <ol>
              <p>
                This EULA shall be governed by, and construed in accordance with, the laws of England and Wales, and the parties irrevocably submit to the exclusive jurisdiction of the English Courts.
              </p>
            </ol>
          </section>
      </div>

    <div className="agreement-button">
      {showEmailOptions ? (
        <div>
          <p>Email: {emailSecond}</p>
	  <p>Email: {email}</p>
	        <button className="emoji-btn" onClick={handleSendEmailClick}>📧</button>
	  	<button className="emoji-btn" onClick={handleCopyClick}>📄</button>
        </div>
      ) : (
        <button className="btn btn-primary" onClick={handleButtonClick}>
          I'll Accept the Agreement, Sign Me Up
        </button>
      )}
    </div>

		</div>
  );
};
export default ContactPage;


